import React from 'react';
import { connect } from 'react-redux';
import reactStringReplace from 'react-string-replace';

import { HOUSEHOLD_USAGE } from '../../config/constants';
import AnimateNumber from '../AnimateNumber';

const Summary = ({ className, data, description, summary, animate }) => {
  const numberFormatter = Intl.NumberFormat('nl-NL', { maximumFractionDigits: 0 });
  let replacedText;

  replacedText = reactStringReplace(description, '{{day}}', () => typeof data['PI-ProducedMWh.AD.SUM'] !== 'undefined' && (
    <AnimateNumber
      toggleBool={animate}
      formattedNumber={numberFormatter.format(data['PI-ProducedMWh.AD.SUM'].value * 1000)}
      endNumber={(data['PI-ProducedMWh.AD.SUM'].value * 1000).toFixed()}
    />
  ));

  replacedText = reactStringReplace(replacedText, '{{month}}', () => typeof data['PI-ProducedMWh.AM.SUM'] !== 'undefined' && (
    <AnimateNumber
      toggleBool={animate}
      formattedNumber={numberFormatter.format(data['PI-ProducedMWh.AM.SUM'].value * 1000)}
      endNumber={(data['PI-ProducedMWh.AM.SUM'].value * 1000).toFixed()}
    />
  ));

  replacedText = reactStringReplace(replacedText, '{{year}}', () => typeof data['PI-ProducedMWh.AY.SUM'] !== 'undefined' && (
    <AnimateNumber
      toggleBool={animate}
      formattedNumber={numberFormatter.format(data['PI-ProducedMWh.AY.SUM'].value * 1000)}
      endNumber={(data['PI-ProducedMWh.AY.SUM'].value * 1000).toFixed()}
    />
  ));

  replacedText = reactStringReplace(replacedText, '{{unit}}', () => (
    <strong>kWh</strong>
  ));

  const summaryValue = reactStringReplace(summary.value, '{{households}}', () => typeof data['PI-ProducedMWh.AY.SUM'] !== 'undefined' && (
    <AnimateNumber
      toggleBool={animate}
      formattedNumber={numberFormatter.format(data['PI-ProducedMWh.AY.SUM'].value / HOUSEHOLD_USAGE)}
      endNumber={(data['PI-ProducedMWh.AY.SUM'].value / HOUSEHOLD_USAGE).toFixed()}
    />
  ));

  return (
    <div className={className}>
      <div className="o-background--grey paragraph--type--windmill-data__block">
        <p className="measurement--description">{ replacedText }</p>
        <div className="row">
          <div className="col-12">
            {
              summaryValue !== '0' ? (
                <div className="measurement--big">
                  <span className="amount summary" content={summaryValue}>{summaryValue}</span> {summary.unit}
                </div>
              ) : (
                <div className="measurement--big">
                  -
                </div>
              )
            }
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    data: state.measurements.getIn(['bazefield', 'measurements']).toJS(),
  };
};


export default connect(mapStateToProps)(Summary);
